import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {yupResolver} from '@hookform/resolvers/yup'
import {useForm} from 'react-hook-form'
import {SaveBillingModel} from '../../../../models/billing.model'
import {savebillingSchema} from '../../../../../../util/validationHoteleria'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {SelectOption} from '../../../../../../models/utility.model'
import {createSaveReportBillingService} from '../../../../services/billing.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  itemToEdit: any
  client: SelectOption[]
  camps: SelectOption[]
  modules: SelectOption[]
  guests: SelectOption[]
  typeRooms: SelectOption[]
}

const ModalSaveReport: FC<Props> = ({
  show,
  setShow,
  itemToEdit,
  client,
  camps,
  modules,
  guests,
  typeRooms,
}) => {
  const handleClose = () => {
    setShow(false)
  }

  const {
    register,
    setValue,
    handleSubmit,
    control,
    formState: {errors},
  } = useForm<SaveBillingModel>({
    resolver: yupResolver(savebillingSchema),
  })
  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit = async (data: any) => {
    try {
      setLoading(true)
      const obj = {...data}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const {data: res} = await createSaveReportBillingService(obj)
      if (!res.error) {
        getSnackBarToast('Se creó con éxito', 'success')
        handleClose()
      } else {
        getSnackBarToast(res.message, 'error')
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setValue('FechaPeriodoIni', itemToEdit?.FechaPeriodoIni)
    setValue('FechaPeriodoFin', itemToEdit?.FechaPeriodoFin)
    setValue('ClienteId', itemToEdit?.ClienteId)
    setValue('CampamentoId', itemToEdit?.CampamentoId)
    setValue('ModuloId', itemToEdit?.ModuloId)
    setValue('HuespedId', itemToEdit?.HuespedId)
    setValue('TipoHabitacionId', itemToEdit?.TipoHabitacionId)
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Guardar Reportes</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='modal-body'>
            <form>
              <div className='row'>
                <div className='col-12'>
                  <label className='required'>Fecha Inicio de Reserva:</label>
                  <InputDate name='FechaPeriodoIni' register={register} errors={errors} disabled />
                </div>
                <div className='col-12'>
                  <label className='required'>Fecha Fin de Reserva:</label>
                  <InputDate name='FechaPeriodoFin' register={register} errors={errors} disabled />
                </div>
                <div className='col-12'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    disabled
                  />
                </div>
                <div className='col-12'>
                  <label className='required'>Campamento:</label>
                  <Select
                    control={control}
                    name='CampamentoId'
                    data={camps}
                    errors={errors}
                    disabled
                  />
                </div>
                <div className='col-12'>
                  <label className='required'>Módulo:</label>
                  <Select
                    control={control}
                    name='ModuloId'
                    data={modules}
                    errors={errors}
                    disabled
                  />
                </div>
                <div className='col-12'>
                  <label className='required'>Huésped:</label>
                  <Select
                    control={control}
                    name='HuespedId'
                    data={guests}
                    errors={errors}
                    disabled
                  />
                </div>
                <div className='col-12'>
                  <label className='required'>Tipo de Habitación:</label>
                  <Select
                    control={control}
                    name='TipoHabitacionId'
                    data={typeRooms}
                    errors={errors}
                    disabled
                  />
                </div>
                <div className='col-12'>
                  <label className='required form-label'>Descripcion Reporte</label>
                  <div
                    className='input-group input-group-sm'
                    style={{
                      width: '97%',
                    }}
                  >
                    <input
                      type='text'
                      className='form-control w-95'
                      {...register('DescripcionReporte')}
                    />
                  </div>
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.DescripcionReporte?.message}
                  </p>
                </div>
              </div>
              <div className='d-flex justify-content-center my-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary d-flex'
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                >
                  Guardar
                  {loading && (
                    <div className='icon-container me-2'>
                      <i className='loader'></i>
                    </div>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalSaveReport}
